import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaginatedListNavigation
  from '../../paginatedlist/PaginatedListNavigation/PaginatedListNavigation';
import {
  refreshFilteredAlertList,
  selectAlertListColumnVisibility,
  selectAlertListPageNo,
  selectAlertListRowsPerPage, selectAlertListTotalResults,
  setAlertListPage,
  setColumnVisibility,
  setRowsPerPage,
} from '../../../redux/slices/alertListSlice/alertListSlice';

/* istanbul ignore next */
function PaginatedAlertListNavigation() {
  const alertListColumns = useSelector((state) => selectAlertListColumnVisibility(state));
  const alertListNumRows = useSelector((state) => selectAlertListRowsPerPage(state));
  const pageNo = useSelector((state) => selectAlertListPageNo(state));
  const totalNumRecords = useSelector((state) => selectAlertListTotalResults(state));
  const dispatch = useDispatch();
  return (
    <div>
      <PaginatedListNavigation
        columnVisibility={alertListColumns}
        currentPage={pageNo}
        onNextPage={() => {
          dispatch(setAlertListPage(pageNo + 1));
          dispatch(refreshFilteredAlertList());
        }}
        onPrevPage={() => {
          dispatch(setAlertListPage(pageNo - 1));
          dispatch(refreshFilteredAlertList());
        }}
        onToggleColumn={(name, visible) => dispatch(
          setColumnVisibility({ columnName: name, visible }),
        )}
        totalResults={totalNumRecords}
        rowsPerPage={alertListNumRows}
        setRowsPerPage={(value) => {
          dispatch(setRowsPerPage(value));
          dispatch(refreshFilteredAlertList());
        }}
      />
    </div>
  );
}

export default PaginatedAlertListNavigation;
